import {
  LandingInfoDocument,
  type LandingInfoQuery,
} from 'src/generated/gql/graphql';
import { client } from 'src/modules/apollo/apolloClient';
import logger from 'src/modules/logger/logger';

export const ensureLearningProfile = async (): Promise<string> => {
  try {
    logger.info('ensureLearningProfile');

    const { data } = await client.query<LandingInfoQuery>({
      query: LandingInfoDocument,
    });

    return data.seekMaxLandingInfo.learningProfileId;
  } catch (error) {
    logger.error({ error }, 'ensureLearningProfile');
    return '';
  }
};
